import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { CustomLink, Body, styled } from '@teko/ds-desktop';
import { getTrackingData } from '../../helpers/tracking.es.js';

const TopbarButton = (_a) => {
    var { children, icon, href, tracking } = _a, rest = __rest(_a, ["children", "icon", "href", "tracking"]);
    return (jsx(CustomLink, Object.assign({ href: href }, { children: jsxs(Button, Object.assign({}, (tracking && getTrackingData(tracking)), rest, { children: [icon && (jsxs(Fragment, { children: [icon, jsx(Spacer, {}, void 0)] }, void 0)), jsx(Body, Object.assign({ level: 1, color: "white" }, { children: children }), void 0)] }), void 0) }), void 0));
};
const Spacer = styled.span `
  width: 0.5rem;
`;
const Button = styled.button `
  padding: 0rem 1.25rem;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  height: 42px;
  &:focus {
    outline: none;
  }
`;

export { TopbarButton };
